import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type AddressDto = ClientInferResponseBody<typeof contract.addresses.findOne>;

export const fetchAddress = async (id: string | undefined): Promise<AddressDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.addresses.findOne.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
